import { useState } from 'react';
import TempsForm from '../components/TempsForm';
import TempsList from '../components/TempsList';
import PageHeader from '../components/PageHeader';
import { Clock } from 'lucide-react';

function TempsPage() {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      fontFamily: '"Noto Sans", sans-serif'
    }}>
      {/* PageHeader */}
      <PageHeader
        icon={Clock}
        title="Saisie des temps"
        subtitle="Saisissez et consultez vos temps travaillés"
      />

      {/* Formulaire */}
      <div style={{ marginBottom: '1.5rem' }}>
        <TempsForm onSuccess={handleSuccess} />
      </div>

      {/* Liste */}
      <TempsList refresh={refreshKey} />
    </div>
  );
}

export default TempsPage;